// extracted by mini-css-extract-plugin
module.exports = {"chatSliderContainer":"az_y5","chatSliderImgContent":"az_z5","liveChat":"az_A5","sr":"az_B5","chatBtn":"az_C5"};